module.exports = __webpack_public_path__ + "img/bb-download-icon.4ed40b8c.svg";